// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Transfer} from '../../core/_models'

type Props = {
  row: Row<Transfer>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()} className="border-bottom border-gray-200 hover-actions-trigger">
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx('text-gray-800 fw-bold text-hover-primary py-4 align-middle')}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
